export default __webpack_public_path__ + "static/media/939.f7aebc69.gif";